import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import IconCheckbox from '@material-ui/icons/CheckBox'
import IconOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined'
import colors from '../../configuration/colors'

export const styles = () => ({
  root: {
    marginRight: 0,
    padding: 0,
    cursor: 'pointer',
    color: colors.rock,
    '&$checked': {
      color: colors.oeYellow
    }
  },
  checked: {
    color: colors.oeYellow,
    marginRight: 0,
    padding: 0
  }
})

const Cb = ({ id, classes, onChange, checked, disabled }) => (
  <Checkbox
    id={id}
    name={id}
    color="primary"
    className="qw-mui-checkbox"
    disableRipple
    checked={checked}
    disabled={disabled}
    checkedIcon={
      <IconCheckbox
        classes={{
          root: disabled ? classes.root : classes.checked
        }}
      />
    }
    icon={
      <IconOutlined
        classes={{
          root: classes.root
        }}
      />
    }
    onChange={onChange}
  />
)

Cb.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
}

export default withStyles(styles)(Cb)
